(() => {
  const init = root => {
    root.querySelectorAll('.gallery').forEach(gallery => {
      if (gallery.closest('[data-six-product]') || gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('.gallery-main');
      const dialog = gallery.closest('.product-section').querySelector('dialog');
      gallery.querySelectorAll('.thumb').forEach(button => button.addEventListener('click', () => {
        main.src = button.dataset.full;
        main.removeAttribute('srcset');
        main.alt = button.querySelector('img').alt;
        gallery.querySelectorAll('.thumb').forEach(el => { el.classList.toggle('selected', el === button); el.setAttribute('aria-pressed', String(el === button)); });
      }));
      gallery.querySelector('.zoom-open').addEventListener('click', () => { dialog.querySelector('img').src = main.currentSrc || main.src; dialog.querySelector('img').alt = main.alt; dialog.showModal(); });
      dialog.querySelector('.zoom-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    });
    root.querySelectorAll('.purchase-form').forEach(form => {
      if (form.closest('[data-six-product]') || form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.querySelectorAll('[name="quantity"]').forEach(radio => radio.addEventListener('change', () => {
        const price = form.querySelector('[data-selected-price]');
        if (price) price.textContent = radio.dataset.price;
      }));
    });
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('js-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
      root.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    }
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
